// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/site_contact.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { SiteContactMarketingStatus } from "../../enum/v1/site_contact_marketing_status_pb.js";

/**
 * @generated from message fingertip.common.type.v1.SiteContact
 */
export const SiteContact = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SiteContact",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "stripe_customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "subscribed_at", kind: "message", T: Timestamp },
    { no: 19, name: "unsubscribed_at", kind: "message", T: Timestamp },
    { no: 20, name: "unsubscribe_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "marketing_status", kind: "enum", T: proto3.getEnumType(SiteContactMarketingStatus) },
    { no: 23, name: "created_at", kind: "message", T: Timestamp },
    { no: 24, name: "updated_at", kind: "message", T: Timestamp },
    { no: 25, name: "business_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "job_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "date_of_birth", kind: "message", T: Timestamp },
    { no: 30, name: "pronouns", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "gender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "setup_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 34, name: "default_address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "billing_address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "shipping_address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

